module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-3.5aa45b2e.jpg";